import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getWorkOrderStatusList as getWorkOrderStatusListApi,
	getWorkOrderStatusListQuery as getWorkOrderStatusListQueryApi,
	getWorkOrderStatus as getWorkOrderStatusApi,
	addNewWorkOrderStatusApi,
	updateWorkOrderStatusApi,
	deleteWorkOrderStatusApi,
	checkWorkOrderStatusExistsApi,
} from '../../helpers/work_order_status/api_helper';

export const getWorkOrderStatusList = createAsyncThunk(
	'workOrderStatus/getWorkOrderStatusList',
	async () => {
		try {
			const response = await getWorkOrderStatusListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los estados de obra.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWorkOrderStatusListQuery = createAsyncThunk(
	'workOrderStatus/getWorkOrderStatusListQuery',
	async params => {
		try {
			const response = getWorkOrderStatusListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWorkOrderStatus = createAsyncThunk(
	'workOrderStatus/getWorkOrderStatus',
	async work_order_status_id => {
		try {
			const response = await getWorkOrderStatusApi(work_order_status_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el estado de obra.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWorkOrderStatus = createAsyncThunk(
	'workOrderStatus/addNewWorkOrderStatus',
	async work_order_status => {
		try {
			const response = await addNewWorkOrderStatusApi(work_order_status);
			toast.success('Estado de Obra agregado exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el estado de obra.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWorkOrderStatus = createAsyncThunk(
	'workOrderStatus/updateWorkOrderStatus',
	async work_order_status => {
		try {
			const response = await updateWorkOrderStatusApi(work_order_status);
			toast.success('Estado de Obra actualizado exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el estado de obra.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWorkOrderStatus = createAsyncThunk(
	'workOrderStatus/deleteWorkOrderStatus',
	async work_order_status => {
		try {
			await deleteWorkOrderStatusApi(work_order_status._id);
			toast.success('Estado de Obra eliminado exitosamente.', {
				autoClose: 3000,
			});
			return work_order_status;
		} catch (error) {
			toast.error('Error al eliminar el estado de obra.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkWorkOrderStatusExists = createAsyncThunk(
	'workOrderStatus/checkWorkOrderStatusExists',
	async name => {
		try {
			const response = await checkWorkOrderStatusExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
